/* SPDX-License-Identifier: AGPL-3.0-or-later */

import { Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserLoginDto } from '@api';

@Component({
  selector: 'app-user-register',
  templateUrl: './user-register.component.html',
  styleUrl: './user-register.component.scss',
})
export class UserRegisterComponent {
  constructor(
    private authService: AuthService,
    private router: Router,
    private snackBar: MatSnackBar,
  ) {}

  /**
   * Send authentication data to the authService. If the registration was
   * successfully, the user will be forwarded to the home page.
   *
   * @param dto registration data from the form
   */
  registerUser(dto: UserLoginDto) {
    console.log('Trying to register user: ' + dto.username);
    this.authService.registerUser(dto).subscribe({
      next: () => {
        console.log(`Successfully registered with username: ${dto.username}`);
        this.snackBar.open(`Successfully registered new user '${dto.username}'`, 'Close', {
          duration: 3000,
        });
        this.router.navigate(['/admin/tournaments']);
      },
      error: error => {
        console.log('Could not register new user due to:');
        console.log(error.error);
        this.snackBar.open(error.error, 'Close', { duration: 5000 });
      },
    });
  }
}
